import { ActionReducer } from '@ngrx/store';
import { localStorageSync } from 'ngrx-store-localstorage';
import { mapReplacer, mapReviver } from '@/app/app.helpers';
import { State } from './store.interface';

export function localStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  const syncReducer = localStorageSync({
    keys: [
      'openedTasks',
      'user',
      'sessionRefresh',
      {
        userPrefs: {
          replacer: mapReplacer,
          reviver: mapReviver
        }
      }
    ],
    rehydrate: true
  })(reducer);

  return (state: State, action: any) => {
    if (action?.avoidPersistence) {
      return reducer(state, action);
    }
    return syncReducer(state, action);
  };
}
